module.exports = __webpack_public_path__ + "static/media/ckn_restaurante_edicion.ab6b9f74.jpg";